"use client"

import MsgDeskSurfaceClient from '../host/MsgDeskSurfaceClient'
import type { DeskSurfaceClientProps } from '../host/surfaceDescriptor'
import { GmailRoutedPage } from './deskUi/GmailRoutedPage'
import { MsgDeskLoading } from './deskUi/MsgDeskLoading'

export default function GmailSurfaceClient(props: DeskSurfaceClientProps) {
  return <MsgDeskSurfaceClient {...props} RoutedPage={GmailRoutedPage} Loading={MsgDeskLoading} />
}
